import { useEffect, useState } from 'react';

// Phone-width layout switch for inline-styled components (no CSS media queries available).
// True at or below 640px. Shared by the Trades Resource Directory screens; components that
// already have their own useIsMobile (768px) keep it for their existing tablet behavior and use
// this only for phone-specific sizing, so desktop and tablet layouts are unchanged.
export const PHONE_QUERY = '(max-width: 640px)';

export default function useIsPhone() {
  const get = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(PHONE_QUERY).matches;
  const [isPhone, setIsPhone] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setIsPhone(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', onChange); else mq.removeListener(onChange); };
  }, []);
  return isPhone;
}
